import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { toaster } from 'components/v2/toast';
import { useCheckReadEpdAccess } from 'services/api/queries';
import EpdRoutes from 'routes/EpdRoutes';

export const withVersionHistoryGuard = (WrappedComponent: React.ComponentType) => {
  const WithVersionHistoryGuard: React.FunctionComponent = () => {
    const { epdId } = useParams<{ epdId: string }>();
    const history = useHistory();
    const { data: hasAccess, isSuccess: accessChecked } = useCheckReadEpdAccess(epdId);

    useEffect(() => {
      if (accessChecked && hasAccess === false) {
        toaster({
          severity: 'error',
          summary: 'Access denied',
          details: 'You do not have permission to access this EPD version log.',
        });
        history.replace(EpdRoutes.dashboard);
      }
    }, [accessChecked, hasAccess, history]);

    if (!accessChecked || hasAccess === false) {
      return null;
    }

    return <WrappedComponent />;
  };

  return WithVersionHistoryGuard;
};
